
import React from "react";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import AIAnalysisTools from "../AIAnalysisTools";

interface MessageFieldProps {
  message: string;
  isAnalyzing: boolean;
  setIsAnalyzing: (isAnalyzing: boolean) => void;
  onMessageChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
  onAIAnalysisComplete: (data: { formattedText: string; voNumber: string | null }) => void;
}

const MessageField = ({ 
  message, 
  isAnalyzing, 
  setIsAnalyzing, 
  onMessageChange, 
  onAIAnalysisComplete 
}: MessageFieldProps) => {
  return (
    <div className="space-y-2">
      <div className="flex items-center justify-between">
        <Label htmlFor="message" className="flex">
          Bericht
          <span className="text-red-500 ml-1">*</span>
        </Label>
        <AIAnalysisTools
          message={message}
          isAnalyzing={isAnalyzing}
          setIsAnalyzing={setIsAnalyzing}
          onAnalysisComplete={onAIAnalysisComplete}
        />
      </div>
      <Textarea
        id="message"
        name="message"
        placeholder="Beschrijf de melding..."
        rows={10}
        value={message}
        onChange={onMessageChange}
        className="min-h-[200px]"
        required
      />
    </div>
  );
};

export default MessageField;
